import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import TeamList from "@/types/Team/TeamList";
let BenefitsAddTeamManagerModal = class BenefitsAddTeamManagerModal extends Vue {
    loadTeams() {
        this.$data.loadingTeams = true;
        this.$store
            .dispatch("adminLoadTeamsAsync")
            .then((result) => {
            this.$data.teamList = new TeamList(result.data);
            this.$data.loadingTeams = false;
            console.log(this.$data.teamList);
        })
            .catch((err) => {
            this.$data.loadingTeams = false;
            window.errorHandler.logError(err, "components/Benefits/BenefitsAddTeamManagerModal.vue -> loadTeams");
        });
    }
    createNewTeamManagerBenefit() {
        this.$data.createTeamManagerBenefit.teamId = this.$data.selectedTeam.id;
        this.$store
            .dispatch("adminUpdateTeamManagerBenefit", {
            userId: this.$props.employee.userId,
            data: this.$data.createTeamManagerBenefit,
        })
            .then((response) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "Team Manager Benefit was added",
            });
            this.$emit("close");
            //send reload event
            window.eventBus.$emit("reloadBenefitsForUser");
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsLevelModal.vue - createNewTeamManagerBenefit");
        });
    }
};
BenefitsAddTeamManagerModal = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                theme: this.$store.getters.getTheme,
                createTeamManagerBenefit: {
                    fixedSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: "",
                    to: null,
                    teamId: "",
                    maxBonus: 0,
                    name: "",
                    workPercentage: 100,
                },
                teamList: [],
                selectedTeam: null,
            };
        },
        props: ["employee"],
        mounted() {
            this.loadTeams();
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit("close"); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                },
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
        },
        components: {
            DatePickerTextbox,
        },
    })
], BenefitsAddTeamManagerModal);
export default BenefitsAddTeamManagerModal;
